import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Contract } from '@models/contract';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ContractsService } from '../contracts.service';

export const contractResolveFn: ResolveFn<Contract> = (route: ActivatedRouteSnapshot) => {
    const contractsService = inject(ContractsService);
    const router = inject(Router);
    const contractId = parseInt(route.paramMap.get('contractId'), 10);

    return contractsService.get(contractId).pipe(
        catchError(() => {
            router.navigateByUrl('/portal/meine-vertraege');
            return EMPTY;
        }),
    );
};
